module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    staticClass: "router",
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view', {
    staticClass: "r"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-87b82234!./~/.1.2.8@vux-loader/src/template-loader.js!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 272
// module chunks = 17